


import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import FloorGallery from '../FloorGallery/index.vue';
import SummaryInfo from '../SummaryInfo/index.vue';
import { FloorOverview as IFloorOverview } from './FloorOverview.models';

@Component({
  components: {
    FloorGallery,
    SummaryInfo
  }
})
export default class FloorOverview extends Vue {
  @Prop() private floorGetter!: string;

  private get overview(): IFloorOverview {
    return this.$store.getters[`summary/${this.floorGetter}`];
  }

  public showOverscroll = false;
  public scrollEndReached = false;
  private resizeHandler: () => void = () => {
    return;
  };
  private scrollHandler: () => void = () => {
    return;
  };

  @Ref('infoContent') public infoContentElement!: HTMLDivElement;

  public scroll() {
    this.infoContentElement.scrollTop = this.scrollEndReached
      ? 0
      : this.infoContentElement.scrollHeight - this.infoContentElement.offsetHeight;
  }

  public mounted() {
    this.checkIfOverscrollIsNeeded();
    this.checkForScrollEnd();

    this.scrollHandler = () => this.checkForScrollEnd();
    this.infoContentElement.addEventListener('scroll', this.scrollHandler);

    this.resizeHandler = () => this.checkIfOverscrollIsNeeded();

    window.addEventListener('resize', this.resizeHandler);
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    if (this.infoContentElement) {
      this.infoContentElement.removeEventListener('scroll', this.scrollHandler);
    }
  }

  private checkIfOverscrollIsNeeded() {
    this.showOverscroll = this.infoContentElement.scrollHeight > this.infoContentElement.offsetHeight;
  }

  private checkForScrollEnd() {
    this.scrollEndReached =
      this.infoContentElement.offsetHeight + this.infoContentElement.scrollTop === this.infoContentElement.scrollHeight;
  }
}
